export default function getNumberOfPostsToRender(fetchedPosts, columns, timesLoaded, settings) {
  // postsToShow is postLimit in S&S
  const {
    hasDisplayLimit,
    hasStaticRows,
    isInfiniteScrollEnabled,
    postCount,
    rowCount,
    postsToShow,
  } = settings

  if (hasDisplayLimit) {
    return Math.min(fetchedPosts, postCount, postsToShow)
  }

  if (!isInfiniteScrollEnabled && hasStaticRows && rowCount) {
    const initialPostsToRender = columns * rowCount
    const totalPostsToRender = initialPostsToRender * timesLoaded
    return Math.min(totalPostsToRender, fetchedPosts, postCount)
  }
  return Math.min(fetchedPosts, postCount)
}
